<template>
  <div>
    <div style="padding: 20px">
      <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="60px">
        <el-form-item label="名称" prop="name" :error="errMsg.name">
          <el-input v-model="formData.name" style="width: 450px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="types" :error="errMsg.types">
          <el-select v-model="formData.types" placeholder="请选择" style="width: 450px" :disabled="isView">
            <el-option label="员工文件" :value="1"> </el-option>
            <el-option label="报销单" :value="2"> </el-option>
            <el-option label="签约合同" :value="3"> </el-option>
            <el-option label="回款表" :value="4"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" :error="errMsg.remark">
          <el-input type="textarea" :rows="3" maxlength="2000" show-word-limit v-model="formData.remark" style="width: 450px" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="fileList" :error="errMsg.fileList">
          <div style="width: 450px; display: flex; flex-wrap: wrap; gap: 5px">
            <div class="thumbnail-container" v-for="(item, index) in formData.fileList" :key="index">
              <el-image class="image" :src="item.url" v-if="item.types == 'img'"> </el-image>
              <el-card shadow="never" :body-style="{ padding: '0px' }" class="att" v-else><i class="el-icon-paperclip icon"></i></el-card>
              <div class="action-buttons">
                <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview({ url: item.url })" v-if="item.types == 'img'"></i>
                <i class="el-icon-download icon" @click="handleDownload(item.url)"></i>
                <i class="el-icon-delete icon" @click="handleRemove(index)" v-if="!isView"></i>
              </div>
            </div>
            <uploads @change="handleChange" v-if="!isView"></uploads>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-but" v-if="!isView">
      <el-button type="primary" :loading="loading" @click="saveData()">保 存</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import uploads from '@/components/storage/uploads';
export default {
  name: 'docSave',
  components: {
    uploads
  },
  props: {
    isView: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  data() {
    return {
      loading: false,
      formData: {
        id: 0,
        name: '',
        types: '',
        fileList: [],
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        types: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        fileList: [{ required: true, message: '请上传文件', trigger: 'blur' }]
      },
      errMsg: {},
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  methods: {
    //上传成功传递数据
    handleChange(file) {
      const url = process.env.VUE_APP_API_URL + '/admin/storage/file/output?filename=' + file.filePath + '&token=' + this.$token();
      const item = { types: file.type, url: url, file_path: file.filePath };
      this.formData.fileList.push(item);
    },
    //删除
    handleRemove(i) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.formData.fileList.splice(i, 1);
        })
        .catch(() => {});
    },
    //浏览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //下载
    handleDownload(url) {
      const link = document.createElement('a');
      link.href = url + '&is_dow=1';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.setEmptyErrMsg();
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        data.fileList = JSON.stringify(data.fileList);
        await this.$api.doc.save(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$emit('callMethod');
          } else {
            for (let k in res.data) {
              this.errMsg[k] = res.data[k];
            }
          }
        });
      });
    },
    //初始化错误信息对象
    setEmptyErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    },
    //获取信息
    setData(id) {
      this.formData.id = id;
      this.getData();
    },
    // 获取数据
    async getData() {
      await this.$api.doc.info({ id: this.formData.id }).then(res => {
        if (res.code == 200 && res.data) {
          this.formData.name = res.data.name;
          this.formData.types = res.data.types;
          this.formData.remark = res.data.remark;
          this.formData.fileList = [];
          res.data.file_list.forEach(file => {
            const url = process.env.VUE_APP_API_URL + '/admin/storage/file/output?filename=' + file.file_path + '&token=' + this.$token();
            const item = { types: file.types, url: url, file_path: file.file_path };
            this.formData.fileList.push(item);
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.thumbnail-container {
  position: relative;
  display: inline-block;
  height: 100px;
}
.thumbnail-container:hover .action-buttons {
  display: flex;
}
.action-buttons {
  display: none;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  position: absolute;
  top: 0;
  right: 0;
}
.action-buttons .icon {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
}
.att {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background-color: #f2f6fc;
}
.att .icon {
  font-size: 48px;
  font-weight: bold;
  color: #e6a23c;
}
</style>
